// extracted by mini-css-extract-plugin
module.exports = {"ArticleTags":"ArticleTags_ArticleTags__1Rbpv","Title":"ArticleTags_Title__3NDd4","Tag":"ArticleTags_Tag__1I51b"};